const fullWordMarkHeader = document.querySelector('.site-header');

const handleNavigationBarOnScroll = () => {
  fullWordMarkHeader.offsetTop > 0 ? fullWordMarkHeader.classList.add('site-header--scrolled') : fullWordMarkHeader.classList.remove('site-header--scrolled');
};

window.addEventListener('load', () => {
  handleNavigationBarOnScroll();
}, false);

window.addEventListener('scroll', () => {
  handleNavigationBarOnScroll();
}, {
  passive: true
});
